import React from 'react';
import PropTypes from 'prop-types';
import securityService from 'core/security/securityService';
import commonService from 'core/common/service/commonService';
import {LoginObjectForm, LoginObject} from 'core/security/loginForm';
import {PageProps} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import {UserContextDto} from "core/security/securityDomain";
import {action} from "mobx";
import {handleFavicon} from "core/common/utils/favicon";



@observer
export default class LoginPage extends React.Component<PageProps, undefined> {

  static title = 'Zauzoo Login';
  static icon = 'lock';
  static rootPage = true;

  static contextTypes = {
    router: PropTypes.func.isRequired
  };


  @action onSubmit = (e) => {

    return securityService.login(securityService.loginObject.username, securityService.loginObject.password)
      .then(action("login-action", (userContextDto: UserContextDto) => {
        let redirectAfterLogin = commonService.redirectAfterLogin;
        this.context.router.transitionTo((redirectAfterLogin && redirectAfterLogin !== '/' && redirectAfterLogin !== '/login') ? redirectAfterLogin : 'home');
      }));


  };


  componentWillMount() {
    securityService.loginObject = new LoginObject({});
  }

  componentWillUnmount() {
    securityService.loginObject = null;
  }

  componentDidMount() {
    handleFavicon(LoginPage);
  }

  render() {
    return (
        <main className="main-content">
          <LoginObjectForm dataObject={securityService.loginObject} rootObject={securityService.loginObject}
                           entities={mdEntityService.entityMap} onSubmit={this.onSubmit}  />
        </main>
    );
  }
}




// WEBPACK FOOTER //
// ./src/core/security/loginPage.tsx